const getDisableUntilTime = action => {
  const time = new Date(action?.disable_until).getTime();
  return Number.isNaN(time) ? null : time;
};

const isDisabledAction = (action, now = Date.now()) => {
  if (action?.disable !== true) return false;

  const disableUntilTime = getDisableUntilTime(action);

  if (!disableUntilTime) return true;

  return disableUntilTime > now;
};

const isPendingDisabledAction = (action, now = Date.now()) => {
  const disableUntilTime = getDisableUntilTime(action);

  return action?.disable === true && disableUntilTime > now;
};

module.exports = {
  getDisableUntilTime,
  isDisabledAction,
  isPendingDisabledAction,
};
